export default __webpack_public_path__ + "static/media/GriegeMv.8f09d140.webp";